export enum WorkflowTemplatesType {
  OpenQuestionsTemplates = 'OpenQuestionsTemplates',
  PipelineTemplates = 'PipelineTemplates',
  EmailTemplates = 'EmailTemplates',
  EvaluationFormsTemplates = 'EvaluationFormsTemplates',
  QuestionnairesTemplates = 'QuestionnairesTemplates',
  ProfileFieldsTemplates = 'ProfileFieldsTemplates',
}

export enum WorkflowTemplatesFeatures {
  Pipeline = 'pipeline',
  ProfileFields = 'profileFields',
  Questionnaires = 'questionnaires',
  EvaluationForms = 'evaluationForms',
  OpenQuestions = 'openQuestions',
  EmailTemplates = 'emailTemplates',
  ReferralQuestions = 'referralQuestions',
}

export type TemplateAssignedOffer = {
  city: string;
  countryCode: string;
  createdAt: string;
  department: string;
  id: number;
  slug: string;
  remote: boolean | null;
  stateCode: string;
  status: string;
  title: string;
  updatedAt: string;
};
